import React from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";

import rootReducer from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";
import { useEffect } from "react";

const TextArea = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let key = databaseKey ? databaseKey : displayLabelKey;

  const displayNo = fieldEle?.["display-no"];
  const displayYes = fieldEle?.["display-yes"];
  // Get the parent key's value from formState
  const parentSelectedValue = displayNo ? formState[displayNo] : "";

  // Check if parentSelectedValue equals "No" (case-insensitive)
  const shouldDisplay = parentSelectedValue?.toLowerCase() === "no";

  if (displayNo && !shouldDisplay) {
    return null;
  }

  const parentValue = displayYes ? formState[displayYes] : "";
  const display = parentValue?.toLowerCase() === "yes";

  useEffect(() => {
    if (displayYes && display === false) {
      rootReducer.dispatch(setRendererFormState({ key: databaseKey, value: "" }));
    }
    if (displayNo && shouldDisplay === false) {
      rootReducer.dispatch(setRendererFormState({ key: databaseKey, value: "" }));
    }
  }, [displayYes, displayNo, display, shouldDisplay, databaseKey]);

  if (displayYes && !display) {
    return null;
  }

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element"
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <textarea
          id={newElfromJSON}
          rows={fieldEle?.["display-rows"]}
          className="form-control mandatory"
          type="text"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          placeholder={fieldEle?.["display-placeholder"]}
          disabled={fieldEle?.["display-disabled"] === 1}
          name={key}
          required={showRequired ? fieldEle?.["display-required"] === 1 : false}
          minLength={fieldEle?.["validation-minlength"]}
          maxLength={fieldEle?.["validation-maxlength"]}
          value={formState[key]}
          onChange={(e) =>
            rootReducer.dispatch(
              setRendererFormState({ key, value: e.target.value })
            )
          }
        />
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default TextArea;
